<template>
  <AdminLayout>
    <Head title="Support" />

    <template #sectionTitle> Support </template>

    <div class="mt-4 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-4xl text-center">
        <h2 class="text-3xl font-semibold text-blue-600">Salve Support</h2>
        <div class="flex justify-center mt-10">
          <div class="mr-2 shrink-0 self-center">
            <PhoneIcon class="h-4 w-4" />
          </div>
          <div class="text-base text-gray-700">
            <span class="font-semibold">Call/SMS Support: </span>
            <a
              class="text-blue-600 hover:text-blue-600"
              href="tel:+13213643271"
              >(321) 364-3271</a
            >
          </div>
        </div>
        <div class="flex justify-center mt-1">
          <div class="mr-2 shrink-0 self-center">
            <MailIcon class="h-4 w-4" />
          </div>
          <div class="text-base text-gray-700">
            <span class="font-semibold">Email Support: </span>
            <a
              class="text-blue-600 hover:text-blue-600"
              href="mailto:support@getsalve.co"
              >support@getsalve.co</a
            >
          </div>
        </div>
        <div class="flex justify-center mt-1">
          <div class="mr-2 shrink-0 self-center">
            <DesktopComputerIcon class="h-4 w-4" />
          </div>
          <div class="text-base text-gray-700">
            <span class="font-semibold">Help Desk: </span>
            <a
              class="text-blue-600 hover:text-blue-600"
              href="https://support.getsalve.co"
              target="_blank"
              >support.getsalve.co</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="mt-10 relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-4xl">
        <dl class="rounded-lg bg-gray-100 shadow-lg sm:grid sm:grid-cols-3">
          <div class="flex flex-col border-b border-gray-400 p-6 text-center sm:border-0 sm:border-r">
            <dt class="order-1 text-lg font-medium leading-6 text-gray-700">Support Hours</dt>
            <dd class="order-2 mt-2 text-3xl font-semibold text-blue-600">8am - 6pm</dd>
            <dd class="order-2 text-2xl font-semibold text-blue-600">M - F</dd>
          </div>
          <div
            class="flex flex-col border-t border-b border-gray-400 p-6 text-center sm:border-0 sm:border-l sm:border-r"
          >
            <dt class="order-1 text-lg font-medium leading-6 text-gray-700">Extended Support</dt>
            <dd class="order-2 mt-2 text-3xl font-semibold text-blue-600">6pm - 10pm</dd>
            <dd class="order-2 text-2xl font-semibold text-blue-600">M - F</dd>
          </div>
          <div class="flex flex-col border-t border-gray-400 p-6 text-center sm:border-0 sm:border-l">
            <dt class="order-1 text-lg font-medium leading-6 text-gray-700">Extended Support</dt>
            <dd class="order-2 mt-2 text-3xl font-semibold text-blue-600">8am - 10pm</dd>
            <dd class="order-2 text-2xl font-semibold text-blue-600">Sat/Sun</dd>
          </div>
        </dl>
      </div>

      <div class="mt-10 text-center">
        <p class="text-base text-gray-700">
          For emergency support, text the above support call/SMS number or email our support address with subject
          "URGENT:***". Responses are guaranteed within regular or extended support hours.
        </p>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'
// import { PhoneIcon } from '@heroicons/vue/solid';
import { PhoneIcon, MailIcon, DesktopComputerIcon } from '@heroicons/vue/outline'

export default {
  components: {
    AdminLayout,
    Head,
    Link,
    PhoneIcon,
    MailIcon,
    DesktopComputerIcon
  }
}
</script>
